import React, { useState, useEffect } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/hooks/useDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';
import MarriageContent from './MarriageContent';

const INIT_FILTER = {
  q: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  sort_by: 'desc',
  module_type: 'MC',
  transaction_type: 'MARRIAGE CERTIFICATE',
};

const civilStatusOption = [
  { label: 'ALL STATUS', value: '' },
  { label: 'FOR EVALUATION', value: 'FOR CHECKING' },
  { label: 'FOR PAYMENT', value: 'FOR PAYMENT' },
  { label: 'FOR APPEARANCE', value: 'FOR APPEARANCE' },
  { label: 'FOR PAYMENT CONFIRMATION', value: 'FOR PAYMENT CONFIRMATION' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'ISSUED', value: 'ISSUED' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'CANCELLED', value: 'CANCELLED' },
];

function MarriageContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  approveTransaction,
  showTransaction,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);

  useEffect(() => {
    getTransactionList(debouncedFilter);
  }, [JSON.stringify(debouncedFilter)]);

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Approve this application?x',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'WAITING FOR PAYMENT',
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'FOR APPEARANCE',
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleOnChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            statusOptions={civilStatusOption}
            moduleName="Marriage Certificate Applications"
            // getData={getTransactionList}
            // setParams={param}
            setKeyword={(e) =>
              handleOnChange(
                e?.target.name,
                e?.target.value
                // e?.target.value.length
              )
            }
            setStatusFilter={(props) =>
              handleOnChange('transaction_status', props?.value)
            }
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="Transaction List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}{' '}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'included.module.attributes.date_marriage')
                    ? moment(
                        _.get(item, 'included.module.attributes.date_marriage')
                      ).format('MM/DD/YYYY')
                    : '---'}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <MarriageContent
                        onApprove={handleApprove}
                        onReject={handleReject}
                        filter={debouncedFilter}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleSort={(props) => handleOnChange('sort_by', props?.value)}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

MarriageContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MarriageContainer);
